import type { ComponentProps } from 'react';
import { format } from 'date-fns';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { cls } from '@/utils/cls';

export type CommunicationSidebarListHeaderProps = {
  month: Date;
  collapsed: boolean;
} & ComponentProps<'div'>;

export function CommunicationSidebarListHeader({
  month,
  collapsed,
  className,
  ...props
}: CommunicationSidebarListHeaderProps) {
  const label = format(month, 'MMMM yyyy');

  return (
    <div
      className={cls(
        'sticky top-0 z-10 flex cursor-pointer items-center justify-between bg-gray-100 px-4 py-2 transition-colors hover:bg-gray-200',
        className,
      )}
      aria-expanded={!collapsed}
      aria-controls={`month-${format(month, 'yyyy-MM')}`}
      {...props}
    >
      <span className="font-condensed text-sm font-medium text-gray-500">
        {label}
      </span>
      <button
        className="text-gray-500 hover:text-gray-700 focus:outline-none"
        aria-label={collapsed ? `Expand ${label}` : `Collapse ${label}`}
      >
        {collapsed ? (
          <ChevronDown className="size-4" />
        ) : (
          <ChevronUp className="size-4" />
        )}
      </button>
    </div>
  );
}
